import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutWireAdvanceQuickInfo extends Layout {
    labelHistoryforthisOrder: Label;
    labelLast7DaystoPayee: Label;
    panelData: Panel;
    panelHeader: Panel;
    panelHistoryByOrder: Panel;
    panelHistoryByPayee: Panel;
    sourceWireAdvanceQuickInfo: DataSource;
    tableDriverAdvanceQuickInfo: Table;
}
